export default __webpack_public_path__ + "static/media/FormFields.1af60b9f.png";